import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function errMessage(e) {
  return e?.response?.data?.detail || e?.message || "Something went wrong. Please try again.";
}
